import { serviceVisitModel } from './serviceVisitModel'
import { routeModel } from './routeModel'
import { customerModel } from './customerModel'

export const calendarModelMapper = {
  mapServiceVisit: serviceVisitModel,
  mapRoute: routeModel,
  mapCustomer: customerModel,
}
